export const manifest = {
  // initial state
  1: state => state,
};

export default (state = { version: 0 }) => state;
